var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var Fily;
(function (Fily) {
    var PC;
    (function (PC) {
        var CopyToClipboard = (function (_super) {
            __extends(CopyToClipboard, _super);
            function CopyToClipboard() {
                return _super !== null && _super.apply(this, arguments) || this;
            }
            CopyToClipboard.prototype.events = function () {
                return {
                    'click / .js-CopyToClipboard--trigger': 'copyToClipboard',
                };
            };
            CopyToClipboard.prototype.copyToClipboard = function (event) {
                var target = $(event.currentTarget).data('copy-target');
                var copyText = $(target).text();
                window.navigator['clipboard'].writeText(copyText);
                var $notice = $('.js-CopyToClipboard--notice');
                $notice.addClass('js-CopyToClipboard--notice-active');
                setTimeout(function () {
                    $notice.fadeOut(1000, function () {
                        $notice.removeClass('js-CopyToClipboard--notice-active');
                        $notice.css('display', '');
                    });
                }, 2000);
            };
            return CopyToClipboard;
        }(Fily.BaseView));
        PC.CopyToClipboard = CopyToClipboard;
    })(PC = Fily.PC || (Fily.PC = {}));
})(Fily || (Fily = {}));
